export { default as DeliveryInformationCard } from './delivery-information-card'
